<template>
  <div>
    <el-button
      style="position: absolute;"
      plain
      type="single-number"
      @click="showDialog()"
    >
      选择用户
    </el-button>
    <el-dialog
      maxHeight="null"
      width="990px"
      title="用户"
      :visible.sync="showDialogVisible"
      custom-class="revenue-code-number"
    >
      <div class="el-dialog__body-bodys">
        <div class="bodys-left">
          <div class="bodys-left-header">
            <el-search
              :formProp="inventoryForm"
              :showIndex="0"
              @search="inventorySearch"
              width="380px"
              placement="bottom-start"
            >
              <template slot="search">
                <el-input
                  v-model="inventoryForm.userName"
                  clearable
                  searchLabel="用户名"
                  placeholder="请输入用户名"
                ></el-input>
                <el-input
                  v-model="inventoryForm.sex"
                  clearable
                  searchLabel="性别"
                  placeholder="请输入性别"
                ></el-input>
                <el-input
                  v-model="inventoryForm.birthday"
                  clearable
                  searchLabel="出生日期"
                  placeholder="请输入出生日期"
                ></el-input>
                <el-input
                  v-model="inventoryForm.politicalOutlook"
                  clearable
                  searchLabel="政治面貌"
                  placeholder="请输入政治面貌"
                ></el-input>
                <el-input
                  v-model="inventoryForm.workYears"
                  clearable
                  searchLabel="工龄"
                  placeholder="请输入工龄"
                ></el-input>
                <el-input
                  v-model="inventoryForm.isMarried"
                  clearable
                  searchLabel="是否已婚"
                  placeholder="请输入是否已婚"
                ></el-input>
                <el-input
                  v-model="inventoryForm.annualIncome"
                  clearable
                  searchLabel="年收入"
                  placeholder="请输入年收入"
                ></el-input>
                <el-input
                  v-model="inventoryForm.idNum"
                  clearable
                  searchLabel="身份证号"
                  placeholder="请输入身份证号"
                ></el-input>
                <el-input
                  v-model="inventoryForm.userMobile"
                  clearable
                  searchLabel="手机号"
                  placeholder="请输入手机号"
                ></el-input>
                <el-input
                  v-model="inventoryForm.hobby"
                  clearable
                  searchLabel="爱好"
                  placeholder="请输入爱好"
                ></el-input>
                <el-input
                  v-model="inventoryForm.remarks"
                  clearable
                  searchLabel="备注"
                  placeholder="请输入备注"
                ></el-input>
              </template>
            </el-search>
          </div>
          <el-table
            :data="inventoryTableDatas"
            maxHeight="380"
            @select="inventorySelectTable"
            ref="inventoryMultipleTable"
            border
            :fit="true"
            style="width: 484px"
          >
            <el-table-column type="selection" width="55" />
            <el-table-column label="序号" width="55">
              <template scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="userName" label="用户名"> </el-table-column>
            <el-table-column prop="sex" label="性别"> </el-table-column>
            <el-table-column prop="birthday" label="出生日期">
            </el-table-column>
            <el-table-column prop="politicalOutlook" label="政治面貌">
            </el-table-column>
            <el-table-column prop="workYears" label="工龄"> </el-table-column>
            <el-table-column prop="isMarried" label="是否已婚">
            </el-table-column>
            <el-table-column prop="annualIncome" label="年收入">
            </el-table-column>
            <el-table-column prop="idNum" label="身份证号"> </el-table-column>
            <el-table-column prop="userMobile" label="手机号">
            </el-table-column>
            <el-table-column prop="hobby" label="爱好"> </el-table-column>
            <el-table-column prop="remarks" label="备注"> </el-table-column>
          </el-table>
          <div
            class="table-footer"
            v-if="this.inventoryTotal != ''"
            style="height: 30px"
          >
            <div class="ccui-table-footer">
              <div id="ccui-paging">
                <el-pagination
                  :total="inventoryTotal"
                  :pager-count="5"
                  :page-size="inventoryPageSize"
                  :current-page="inventoryPageNoCode"
                  prev-text="< 上一页"
                  next-text="下一页 >"
                  background
                  layout=" prev, pager, next, jumper"
                  popper-class="ccui-paging-page-size-popper"
                  @current-change="inventoryHandleCurrentChange"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="bodys-right">
          <div class="bodys-right-header">
            已选择({{ inventoryTableData2.length }}个)
          </div>
          <div class="bodys-right-box">
            <el-table
              :data="inventoryTableData2"
              ref="multipleTable2"
              maxHeight="489"
              border
              :fit="true"
              style="width: 387px"
            >
              <el-table-column label="序号" width="55">
                <template scope="scope">
                  <span>{{ scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="userName" label="用户名">
              </el-table-column>
              <el-table-column prop="sex" label="性别"> </el-table-column>
              <el-table-column prop="birthday" label="出生日期">
              </el-table-column>
              <el-table-column prop="politicalOutlook" label="政治面貌">
              </el-table-column>
              <el-table-column prop="workYears" label="工龄"> </el-table-column>
              <el-table-column prop="isMarried" label="是否已婚">
              </el-table-column>
              <el-table-column prop="annualIncome" label="年收入">
              </el-table-column>
              <el-table-column prop="idNum" label="身份证号"> </el-table-column>
              <el-table-column prop="userMobile" label="手机号">
              </el-table-column>
              <el-table-column prop="hobby" label="爱好"> </el-table-column>
              <el-table-column prop="remarks" label="备注"> </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    type="text"
                    @click="inventoryDeleteTable(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="showDialogVisible = false"
          >取 消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="inventoryConfirm"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listDemoUserPage } from "../../api/";
export default {
  name: "inventory",
  data() {
    return {
      showDialogVisible: false,
      inventoryForm: {},
      inventoryTableDatas: [],
      inventoryTotal: 0,
      inventoryPageNoCode: 1,
      inventoryPageSize: 20,
      inventoryTableData2: []
    };
  },
  methods: {
    showDialog() {
      this.showDialogVisible = true;
      this.inventoryGetMcConcBill();
    },
    inventoryGetMcConcBill() {
      let params = {
        pageNo: this.inventoryPageNoCode,
        pageSize: this.inventoryPageSize,
        ...this.inventoryForm
      };
      listDemoUserPage(params).then(res => {
        this.inventoryTableDatas = res.data.data.rows;
        this.inventoryTotal = res.data.data.recordsTotal;
        this.inventoryPageNoCode = res.data.data.pageNo;
      });
    },
    inventoryHandleCurrentChange(val) {
      this.inventoryPageNoCode = val;
      this.inventoryGetMcConcBill();
    },
    inventorySearch(searchData) {
      this.inventoryPageNoCode = 1;
      this.inventoryForm = searchData;
      this.inventoryGetMcConcBill();
    },
    inventorySelectTable(val) {
      this.inventoryTableData2 = val;
    },
    inventoryDeleteTable(e) {
      this.inventoryTableData2 = this.inventoryTableData2.filter(
        item => item.id !== e.id
      );
      let filterArr = this.inventoryTableData2.filter(item => item.id !== e.id);
      this.$refs.inventoryMultipleTable.clearSelection();
      filterArr.forEach(row => {
        this.$refs.inventoryMultipleTable.toggleRowSelection(row);
      });
    },
    inventoryConfirm() {
      this.showDialogVisible = false;
      alert(JSON.stringify(this.inventoryTableData2));
      this.$emit("inventoryConfirm", this.inventoryTableData2);
    }
  }
};
</script>

<style scoped></style>
